export function extractEmailFromUrl(url: string): string {
  try {
    // Remove leading/trailing slashes and decode
    const cleanPath = url.replace(/^\/|\/$/g, '');
    const parts = cleanPath.split('/');
    const encodedEmail = parts[parts.length - 1];
    
    // Remove any leading colon if present (from route parameter)
    const cleanEmail = encodedEmail.replace(/^:/, '');
    
    // Decode and clean the email
    const decodedEmail = decodeURIComponent(cleanEmail);
    return decodedEmail.toLowerCase().trim();
  } catch (error) {
    console.error('Error extracting email from URL:', error);
    throw new Error('Invalid email parameter in URL');
  }
}